var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 74.98,
    x2: 437.02,
    y1: 74.98,
    y2: 437.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffda17",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#4edac1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0ac3f8",
    offset: 0.9691357450539038
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0a15f8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 200.77,
    x2: 445.26,
    y1: 184.29,
    y2: 428.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#cc9a06",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "#1956ff",
    offset: 0.93
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#a)",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M500.19 333.08a256.72 256.72 0 0 1-143.08 158.17L252.34 386.48l27.86-25.73-27.86-27.85 9.83-42.76-79-79c31.91-68.8 122.34-72.72 122.34-72.72z",
    opacity: 1,
    "data-original": "url(#b)",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.33 121a79.15 79.15 0 0 0-80.25 76.31v.72a16.31 16.31 0 0 0 16.33 16.67h7.74A16.87 16.87 0 0 0 218 198.45v-.43a38.05 38.05 0 1 1 38.2 40h-.37a9.53 9.53 0 0 0-9.62 9.51v9.61a.38.38 0 0 0 0 .1v61.59a19.22 19.22 0 0 0 19.2 19.17 19.21 19.21 0 0 0 19.22-19.22v-45.23A79 79 0 0 0 257.33 121z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.41,
    cy: 369.83,
    r: 21.17,
    transform: "rotate(-45 265.36 369.901)",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubts);
export default __webpack_public_path__ + "static/media/doubts.b36ccecfe15bcf4632b4e26529eb3413.svg";
export { ForwardRef as ReactComponent };